export function getNames(e: any): string[] {
  return Object.keys(e).filter(function (key) { return isNaN(+key); });
}

export function getValues<T extends string | number>(e: any): T[] {
  return getNames(e).map(function (name) { return e[name]; });
}
